"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.write = void 0;
var Codec = require("./../../io/codec");
/**
 * Write a {@link JSONCondition}.
 *
 * @since 6.10
 */
function write(bos, condition) {
    Codec.writeByte(bos, condition.operator);
    Codec.writeByte(bos, condition.valueType);
    Codec.writeBytes(bos, condition.buffer);
}
exports.write = write;
